import { __decorate } from "tslib";
import { Timer } from './Timer';
import { Updatable } from '../../Core/DI';
/**
 * 定时器管理器
 *
 * 允许动作的延迟和重复执行
 */
let TimerManager = class TimerManager {
    constructor() {
        this._timers = [];
    }
    update() {
        for (let i = this._timers.length - 1; i >= 0; i--) {
            if (this._timers[i].tick()) {
                this._timers[i].unload();
                this._timers.splice(i, 1);
            }
        }
    }
    /**
     * 调度一个一次性或重复的计时器，该计时器将调用已传递的动作
     * @param timeInSeconds
     * @param repeats
     * @param context
     * @param onTime
     */
    schedule(timeInSeconds, repeats, context, onTime) {
        const timer = new Timer();
        timer.initialize(timeInSeconds, repeats, context, onTime);
        this._timers.push(timer);
        return timer;
    }
    /**
     * 释放资源
     */
    dispose() {
        for (const timer of this._timers) {
            timer.unload();
        }
        this._timers = [];
    }
};
TimerManager = __decorate([
    Updatable()
], TimerManager);
export { TimerManager };
//# sourceMappingURL=TimerManager.js.map